import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useFetchGet } from '../../utils/fetch/useFetchGet';
import { IDelivery } from '../../utils/types';
import { paths, pathsApi } from '../../router/paths';
import Body from '../../ui/Body/body';
import i18n from '../../utils/i18n';
import s from '../Product/styles/product.module.scss';
import GridCol from '../../ui/GridCol';
import { ButtonVariationEnum } from '../../ui/Button/types';
import Button from '../../ui/Button';
import GridRow from '../../ui/GridRow';
import TextItem from '../../ui/TextItem/textItem';
import Tag from '../../ui/Tag';
import { TagEnum } from '../../ui/Tag/types';
import { boolToReadable } from '../../utils/boolUtil';
import { getPrice } from '../../utils/getPrice';
import Card from '../../ui/Card';
import { IconEnum } from '../../ui/Icon';
import Details from '../../ui/Details/details';

const Delivery = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { data } = useFetchGet<IDelivery>({
        path: pathsApi.delivery + id,
        defaultValue: globalThis.history.state?.usr?.delivery?.id && globalThis.history.state.usr.delivery,
    });

    if (!data) return <Body title={i18n.general.loading} isLoading={true} />;

    const editProduct = () => {
        navigate(paths.delivery + id + '/edit', { state: { delivery: data } });
    };

    return (
        <Body title={data.name}>
            <GridRow gutter={16} className={s.root}>
                <GridCol col={12} className={s.buttonBlock}>
                    <Button onClick={editProduct} variation={ButtonVariationEnum.SOFT}>
                        {i18n.general.edit}
                    </Button>
                </GridCol>
                <GridCol col={8}>
                    <GridRow gutter={16}>
                        <GridCol col={6}>
                            <TextItem label={i18n.general.name} text={data.name} />
                        </GridCol>
                        <GridCol col={6}>
                            <TextItem label={i18n.price.mainPrice} text={getPrice(data.price)} />
                        </GridCol>
                        <GridCol col={6}>
                            <TextItem label={i18n.product.isVisible}>
                                <Tag type={!!data.deletedAt ? TagEnum.RED : TagEnum.GREEN}>
                                    {boolToReadable(!data.deletedAt)}
                                </Tag>
                            </TextItem>
                        </GridCol>
                    </GridRow>
                </GridCol>
                <GridCol col={4} className={s.sideBlock}>
                    <Card>
                        <TextItem label={i18n.general.updated} text={data.updatedAt} />
                    </Card>
                </GridCol>
                <GridCol col={12}>
                    <Details label={i18n.delivery.conditions} icon={IconEnum.DOCS}>
                        <GridRow column gutter={8}>
                            {data.options?.map((item) => <Tag key={item}>{item}</Tag>)}
                        </GridRow>
                    </Details>
                </GridCol>
            </GridRow>
        </Body>
    );
};

export default Delivery;
